import { useEffect, useRef } from "react";
import { Helmet } from "react-helmet-async";
import "../../styles/penalty-recovery.css";
import useCtaWiring from "../../hooks/useCtaWiring";
import termsBody from "./_generated/termsBody";

/** COVID Penalty Recovery — Terms of Service (product-specific legal page). */
export default function PenaltyRecoveryTerms() {
  const rootRef = useRef(null);
  useCtaWiring(rootRef, "terms");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="pr-page pr-legal" ref={rootRef} data-testid="penalty-recovery-terms">
      <Helmet>
        <title>Terms of Service — COVID Penalty Recovery | KGOB</title>
        <meta name="description" content="Terms of Service for the KGOB COVID-Era IRS Penalty &amp; Interest Review product." />
        <link rel="canonical" href="https://kgob.com/penalty-recovery/termsofservice" />
      </Helmet>
      <div dangerouslySetInnerHTML={{ __html: termsBody }} />
    </div>
  );
}
